import { DisplayableFile } from "src/app/angular-elements/form-wrappers/form-components/required-docs-upload/interfaces/displayable-file.interface";

export interface LifeEventDocumentUpload {
  displayableFileObj: DisplayableFile;
  doctype?: string;
}

export interface LifeEventStateStructure {
  documents: LifeEventDocumentUpload[];
  isDocumentUploadRequired: boolean;
  minRequired: number;
}

/**
 * These map the dropdown value from the UI to the value consumed by the backend when checking boxes on a print-paper-pdf
 */
export enum DOCUMENT_UPLOAD_TYPES {
  "Birth Certificate" = "BIRTH_CERTIFICATE",
  "COBRA coverage termination notice" = "COBRA_COVERAGE_TERM_NOTICE",
  "COBRA eligibility notice" = "COBRA_ELIGIBILTY_NOTICE",
  "Copy of MNsure eligibility notice" = "FINANCIAL_CHANGE",
  "Court Order" = "COURT_ORDER",
  "Coverage termination letter" = "COVERAGE_TERMINATION",
  "Coverage termination letter/notice" = "COVERAGE_TERMINATION",
  "Coverage termination notice" = "COVERAGE_TERMINATION",
  "Deed" = "DEED",
  "Departure date paperwork" = "MILITARY_SERVICE",
  "Driver's License or State Photo ID" = "DRIVER_LICENSE_PHOTO_ID",
  "Employer COBRA contributions termination notice" = "EMP_COBRA_CONTRIBUTIONS_TERM_NOTICE",
  "ICHRA form" = "ICHRA",
  "Legal papers for adoption" = "LEGAL_PAPERS_ADOPTION",
  "Legal papers for foster care" = "LEGAL_PAPERS_FOSTER_CARE",
  "Marriage Certificate" = "MARRIAGE_CERTIFICATE",
  "Non-calendar year policy termination notice" = "NON_CALENDAR_YR_POLICY_TERM_NOTICE",
  "Other" = "OTHER",
  "Prison release form" = "PRISON_RELEASE_FORM",
  "Proof from prior carrier of MEC" = "PROOF_PRIOR_CARRIER_MEC",
  "Proof of address change" = "PROOF_ADDRESS_CHANGE",
  "Proof of claims for birth" = "PROOF_CLAIMS_BIRTH",
  "Purchase Agreement" = "PURCHASE_AGREEMENT",
  "QSEHRA form" = "QSEHRA",
  "Rental/lease agreement" = "RENTAL_LEASE_AGREEMENT",
  "Utility Bill" = "UTILITY_BILL",
}
